// export const baseUrl = "http://localhost:8000/";
export const baseUrl = "https://api.pankajjewellers.co/";

export const GetAllCilentDetails = async () => {
  const data = await fetch(`${baseUrl}admin/get_client_details`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};

export const GetAllCategory = async () => {
  const data = await fetch(
    `${baseUrl}products/view_all_category_with_subcategory`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  const _data = await data.json();
  return _data;
};

export const GetAllSlider = async () => {
  let url = `${baseUrl}order/allslider1`;

  const data = await fetch(url, {
    method: "POST",
    headers: {},
  });
  const _data = await data.json();
  return _data;
};
export const GetTrendingProduct = async () => {
  let url = `${baseUrl}products/homepage_Tranding`;

  const data = await fetch(url, {
    method: "POST",
    headers: {},
  });
  const _data = await data.json();
  return _data;
};

export const GetAllProduct = async (formData) => {
  const data = await fetch(`${baseUrl}products/view_all_product_by_category`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const GetAllDashboardProduct = async (formData) => {
  const data = await fetch(`${baseUrl}products/dashboard_product`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const GetAllFilterProduct = async (formData) => {
  const data = await fetch(
    `${baseUrl}products/view_all_filter_product_by_category`,
    {
      method: "POST",
      headers: {},
      body: formData,
    },
  );
  const _data = await data.json();
  return _data;
};

export const GetAllProductDetails = async (formData) => {
  const data = await fetch(`${baseUrl}products/product_page`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const GetAllProductReview = async (formData) => {
  const data = await fetch(`${baseUrl}user/get_all_review`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const AddProductReview = async (formData) => {
  const data = await fetch(`${baseUrl}user/add_product_review`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const loginUser = async (formData) => {
  const data = await fetch(`${baseUrl}user/issue_otp_web`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const verifyLoginOtp = async (formData) => {
  const data = await fetch(`${baseUrl}user/checkOTP`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const RegisterUser = async (formData) => {
  const data = await fetch(`${baseUrl}user/register_user`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const AddToCart = async (formData) => {
  const data = await fetch(`${baseUrl}order/update_cart`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

// Profile related APIs
export const getUserProfile = async (token) => {
  const data = await fetch(`${baseUrl}user/profile`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ Token: token }),
  });
  const _data = await data.json();
  return _data;
};

export const updateUserProfile = async (formData) => {
  const data = await fetch(`${baseUrl}user/edit_profile`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const changeEmail = async (formData) => {
  const data = await fetch(`${baseUrl}user/change_email_web`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const verifyEmail = async (formData) => {
  const data = await fetch(`${baseUrl}user/verify_email`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const changeMobile = async (formData) => {
  const data = await fetch(`${baseUrl}user/change_mobilenum_web`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const verifyMobile = async (formData) => {
  const data = await fetch(`${baseUrl}user/verify_mobile`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const verifyOTP = async (formData) => {
  const data = await fetch(`${baseUrl}user/checkOTP`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const GetAllCart = async (formData) => {
  const data = await fetch(`${baseUrl}order/show_cart`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const checkCouponCodeApi = async (formData) => {
  const data = await fetch(`${baseUrl}order/CheckCoupon`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const addAddress = async (formData) => {
  const data = await fetch(`${baseUrl}user/add_address`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const getAllUserAddress = async (formData) => {
  const data = await fetch(`${baseUrl}user/address`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const editAddress = async (formData) => {
  const data = await fetch(`${baseUrl}user/edit_address`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const getAddresses = async (token) => {
  const data = await fetch(`${baseUrl}user/get_addresses`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ Token: token }),
  });
  const _data = await data.json();
  return _data;
};

export const deleteAddress = async (formData) => {
  const data = await fetch(`${baseUrl}user/delete_address`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const GetWishlist = async (formData) => {
  try {
    console.log("Making GetWishlist API call with formData:", {
      Token: formData.get("Token"),
    });

    const response = await fetch(`${baseUrl}products/wishlist_page`, {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("GetWishlist API response:", data);
    return data;
  } catch (error) {
    console.error("Error in GetWishlist API:", error);
    throw error;
  }
};

export const DeleteWishlist = async (formData) => {
  try {
    const response = await fetch(`${baseUrl}products/delete_wishlist`, {
      method: "POST",
      body: formData,
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const AddToWishlist = async (formData) => {
  try {
    const response = await fetch(`${baseUrl}products/add_wishlist`, {
      method: "POST",
      body: formData,
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const checkoutApi = async (formData) => {
  const data = await fetch(`${baseUrl}order/SaveOrder`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};
export const paymentDoneApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/paymentdone`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const getAllOrders = async (formData) => {
  const data = await fetch(`${baseUrl}order/SingleActiveUserOrder`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const getInvoice = async (formData) => {
  const data = await fetch(`${baseUrl}order/getpdf`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const submitContactForm = async (formData) => {
  try {
    const response = await fetch(`${baseUrl}admin/contact_us`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error in contact form submission:", error);
    throw error;
  }
};

export const adminLoginApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/AdminLogin`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminDashboardApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/OrderStats`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminAllProduct = async (formData) => {
  const data = await fetch(`${baseUrl}admin/all_products`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminSingleImageUploadApi = async (formData) => {
  const data = await fetch(`${baseUrl}products/add_productImg`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminMultipleImageUploadApi = async (formData) => {
  const data = await fetch(`${baseUrl}products/add_multiproductImg`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminProductUploadApi = async (formData) => {
  const data = await fetch(`${baseUrl}products/add_product`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};
export const adminGetProductDetails = async (formData) => {
  const data = await fetch(`${baseUrl}products/edit_product`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminUpdateProductApi = async (formData) => {
  const data = await fetch(`${baseUrl}products/set_edit_product`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};
export const adminTrashProductApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/trash_product`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminImportProductApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/upload_file`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminBulkUploadProductsApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/bulk_upload_products`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminGetCategoriesForBulkUploadApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/get_categories_for_bulk_upload`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};
export const adminAllTrashProduct = async (formData) => {
  const data = await fetch(`${baseUrl}admin/alltrash_product`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminDeleteProductApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/del_product`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminRestoreProductApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/untrash_product`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminAllPromocode = async (formData) => {
  const data = await fetch(`${baseUrl}admin/view_allcoupons`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminDeletePromocodeApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/delete_coupon`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminStorePromocode = async (formData) => {
  const data = await fetch(`${baseUrl}admin/add_new_coupon`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminUpdatePromocode = async (formData) => {
  const data = await fetch(`${baseUrl}admin/edit_coupon`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminAllUser = async (formData) => {
  const data = await fetch(`${baseUrl}admin/all_user`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminUserProfile = async (formData) => {
  const data = await fetch(`${baseUrl}admin/profile`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminUpdateUser = async (formData) => {
  const data = await fetch(`${baseUrl}admin/edit_profile`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};
export const adminUserLiveCart = async (formData) => {
  const data = await fetch(`${baseUrl}products/checkout_admin`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminUserCartHistory = async (formData) => {
  const data = await fetch(`${baseUrl}admin/viewcartorderstatus`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminAllMessage = async (formData) => {
  const data = await fetch(
    `${baseUrl}admin/all_contact?Token=${formData.Token}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  const _data = await data.json();
  return _data;
};
export const adminAllDeleteRequest = async (formData) => {
  const data = await fetch(
    `${baseUrl}admin/all_delete_request?Token=${formData.Token}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  const _data = await data.json();
  return _data;
};
export const adminAllRefundRequest = async (formData) => {
  const data = await fetch(
    `${baseUrl}admin/all_refund_request?Token=${formData.Token}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  const _data = await data.json();
  return _data;
};
export const adminAllTestimonial = async () => {
  const data = await fetch(`${baseUrl}admin/get_testimonial_list`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};
export const adminAllNewsLetter = async (formData) => {
  const data = await fetch(
    `${baseUrl}admin/all_newsletter_request?Token=${formData.Token}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  const _data = await data.json();
  return _data;
};

export const adminAllNotification = async (formData) => {
  const data = await fetch(`${baseUrl}admin/view_general_notification`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};
export const adminStoreNotification = async (formData) => {
  const data = await fetch(`${baseUrl}admin/add_notification`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminAllSlider = async (formData) => {
  const data = await fetch(`${baseUrl}order/allslider1`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminDeleteSliderApi = async (formData) => {
  const data = await fetch(`${baseUrl}order/deleteslider1`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminStoreSlider = async (formData) => {
  const data = await fetch(`${baseUrl}order/addslider1`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminUpdateSlider = async (formData) => {
  const data = await fetch(`${baseUrl}order/editslider1`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminAllCategory = async (formData) => {
  const data = await fetch(`${baseUrl}products/get_category`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminTrashCategoryApi = async (formData) => {
  const data = await fetch(`${baseUrl}products/delete_category`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminStoreCategory = async (formData) => {
  const data = await fetch(`${baseUrl}products/add_category`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminUpdateCategory = async (formData) => {
  const data = await fetch(`${baseUrl}products/edit_category`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminAllSubCategory = async (formData) => {
  const data = await fetch(`${baseUrl}products/get_all_subcategory`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const _data = await data.json();
  return _data;
};
export const adminTrashSubCategoryApi = async (formData) => {
  const data = await fetch(`${baseUrl}products/delete_subcategory`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};
export const adminStoreSubCategory = async (formData) => {
  const data = await fetch(`${baseUrl}products/add_subcategory`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};
export const adminUpdateSubCategory = async (formData) => {
  const data = await fetch(`${baseUrl}products/edit_subcategory`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminAllOrder = async (formData) => {
  const data = await fetch(`${baseUrl}admin/allorder`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminTrashOrderApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/trash_order`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminAllTrashOrder = async (formData) => {
  const data = await fetch(`${baseUrl}admin/alltrash_order`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminDeleteOrderApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/delete_order`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminRestoreOrderApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/untrash_order`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminOrderDetailsApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/eachorder`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminUpdateOrderStatusApi = async (formData) => {
  const data = await fetch(`${baseUrl}admin/changestatus`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};
export const adminGenerateInvoiceApi = async (formData) => {
  const data = await fetch(
    `${baseUrl}admin/generate_pdf?Token=${formData.Token}&OrderGroupId=${formData.OrderGroupId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  const _data = await data.json();
  return _data;
};
export const adminGeneratePaySlipApi = async (formData) => {
  const data = await fetch(
    `${baseUrl}admin/delivery_slip?Token=${formData.Token}&OrderGroupId=${formData.OrderGroupId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  const _data = await data.json();
  return _data;
};
export const adminGetInvoicePdfApi = async (formData) => {
  const data = await fetch(`${baseUrl}order/getpdf`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminAddOrderNoteApi = async (formData) => {
  const data = await fetch(`${baseUrl}order/AddNote`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const GetAllCollections = async (formData = {}) => {
  const data = await fetch(`${baseUrl}products/get_collections`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const GetCollectionProducts = async (formData) => {
  const data = await fetch(`${baseUrl}products/get_collection_products`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminAllCollections = GetAllCollections;

export const adminStoreCollection = async (formData) => {
  const data = await fetch(`${baseUrl}products/add_collection`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminUpdateCollection = async (formData) => {
  const data = await fetch(`${baseUrl}products/edit_collection`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminDeleteCollection = async (formData) => {
  const data = await fetch(`${baseUrl}products/delete_collection`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminGetCollectionProducts = GetCollectionProducts;

export const adminSetCollectionProducts = async (formData) => {
  const data = await fetch(`${baseUrl}products/set_collection_products`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminProductsForCollectionPicker = async (formData) => {
  const data = await fetch(
    `${baseUrl}products/get_products_for_collection_picker`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    }
  );
  const _data = await data.json();
  return _data;
};

export const GetAllStylings = async (formData = {}) => {
  const data = await fetch(`${baseUrl}products/get_stylings`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminAllStylings = GetAllStylings;

export const adminStoreStyling = async (formData) => {
  const data = await fetch(`${baseUrl}products/add_styling`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminUpdateStyling = async (formData) => {
  const data = await fetch(`${baseUrl}products/edit_styling`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminDeleteStyling = async (formData) => {
  const data = await fetch(`${baseUrl}products/delete_styling`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminGetStylingProducts = async (formData) => {
  const data = await fetch(`${baseUrl}products/get_styling_products`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminSetStylingProducts = async (formData) => {
  const data = await fetch(`${baseUrl}products/set_styling_products`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const GetNewArrivals = async (formData = {}) => {
  const data = await fetch(`${baseUrl}products/get_new_arrivals`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};

export const adminGetNewArrivals = GetNewArrivals;

export const adminUpdateNewArrivalBanner = async (formData) => {
  const data = await fetch(`${baseUrl}products/update_new_arrival_banner`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminStoreNewArrivalCard = async (formData) => {
  const data = await fetch(`${baseUrl}products/add_new_arrival_card`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminUpdateNewArrivalCard = async (formData) => {
  const data = await fetch(`${baseUrl}products/edit_new_arrival_card`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const _data = await data.json();
  return _data;
};

export const adminDeleteNewArrivalCard = async (formData) => {
  const data = await fetch(`${baseUrl}products/delete_new_arrival_card`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
  const _data = await data.json();
  return _data;
};
